import { render, staticRenderFns } from "./create.vue?vue&type=template&id=db2d2fc6&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db2d2fc6')) {
      api.createRecord('db2d2fc6', component.options)
    } else {
      api.reload('db2d2fc6', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=db2d2fc6&", function () {
      api.rerender('db2d2fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms_portal/users/create.vue"
export default component.exports